import React, { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";

import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import i18next from "i18next";
import { useNavigate } from "react-router-dom";

const initialState = {
  name: "",
  email: "",
  message: "",
  phoneNumber: "",
  typeOfRequest: "",
  typeOfActivity: "",
  address: "",
  city: "",
  country: "",
  honey: "", // honeypot field
};

export const Contact = (props) => {
  const { t } = useTranslation();
  const [formState, setFormState] = useState(initialState);
  const formStartTime = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    formStartTime.current = Date.now();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setFormState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formState.honey) return; // honeypot check
    if (Date.now() - formStartTime.current < 2000) return; // bot check

    const emailMessage = `
Name: ${formState.name}
Email: ${formState.email}
Phone: ${formState.phoneNumber}
Type of Request: ${formState.typeOfRequest}
Type of Activity: ${formState.typeOfActivity}
Address: ${formState.address}
City: ${formState.city}
Country: ${formState.country}

Message:
${formState.message}
`;

    emailjs
      .send(
        "service_8hr46gh",
        "template_gw0dy9i",
        { ...formState, message: emailMessage },
        "GU98_tVqfo69jyFjZ"
      )
      .then(
        () => {
          toast.success(t("emailSentSuccess") || "Email sent successfully!");

          clearState();
          formStartTime.current = Date.now();
          setTimeout(() => {
            navigate("/thank-you");
          }, 1500);
        },

        () => {
          toast.error(
            t("emailSentError") ||
              "Failed to send email. Please try again later."
          );
        }
      );
  };

  return (
    <div className="trial-form">
      <ToastContainer />
      <div id={props.temp === "career-form" ? "career" : "contact"}>
        <div className="container">
          <img src="/img/logo-g.png" alt="" width="400" className="form-logo" />
          <div className="col-md-8 form-right">
            <div className="row">
              <div className="section-title">
                <h2>{t("request")}</h2>
                <p>{t("trial-text")}</p>
              </div>
              <form
                name="sentMessage"
                validate
                onSubmit={handleSubmit}
                dir="rtl"
              >
                {/* Honeypot hidden input */}
                <input
                  type="text"
                  name="honey"
                  style={{ display: "none" }}
                  tabIndex={-1}
                  autoComplete="off"
                  onChange={handleChange}
                />

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder={t("email")}
                        required
                        onChange={handleChange}
                        value={formState.email}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder={t("name")}
                        required
                        onChange={handleChange}
                        value={formState.name}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="tel"
                        id="phoneNumber"
                        name="phoneNumber"
                        className="form-control"
                        placeholder={t("phoneNumber")}
                        onChange={handleChange}
                        value={formState.phoneNumber}
                        style={{
                          direction: i18next.language === "ar" ? "rtl" : "ltr",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="typeOfRequest"
                        name="typeOfRequest"
                        className="form-control"
                        placeholder={t("typeOfRequest")}
                        onChange={handleChange}
                        value={formState.typeOfRequest}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="typeOfActivity"
                        name="typeOfActivity"
                        className="form-control"
                        placeholder={t("typeOfActivity")}
                        onChange={handleChange}
                        value={formState.typeOfActivity}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="address"
                        name="address"
                        className="form-control"
                        placeholder={t("address")}
                        onChange={handleChange}
                        value={formState.address}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="city"
                        name="city"
                        className="form-control"
                        placeholder={t("city")}
                        onChange={handleChange}
                        value={formState.city}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="country"
                        name="country"
                        className="form-control"
                        placeholder={t("country")}
                        onChange={handleChange}
                        value={formState.country}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder={t("message")}
                    required
                    onChange={handleChange}
                    value={formState.message}
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-custom btn-lg">
                  {t("submit")}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
  );
};
